var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbt-content-box',{attrs:{"loading":_vm.loading,"loading-error":_vm.loadingError,"no-content":_vm.noContent,"title":"Package Items"}},[_c('vbt-table',{attrs:{"headers":_vm.headers,"items":_vm.packageReturnItems,"show-paginator":""},scopedSlots:_vm._u([{key:"orderId",fn:function(ref){
var orderId = ref.item.orderId;
return [_c('router-link',{staticClass:"info--text",attrs:{"to":{
          name: 'order',
          params: { id: orderId },
          query: { suffix: _vm.suffix },
        },"target":"_blank"}},[_vm._v(" "+_vm._s(orderId)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }